import { createSlice } from "@reduxjs/toolkit";

const initialState = { open: false, msg: "", severity: "info" };

const sideStatusSlice = createSlice({ name: "side-status", initialState });

export default sideStatusSlice.reducer;
